import { Executor, FromSchema } from '@40seas/entities/common';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';
import { Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditSafeCompanySearchQuery, CreditSafeCompanySearchQuerySchema } from './credit-safe.company.search.query';
import { CreditSafeCompanySearchResult, CreditSafeCompanySearchResultSchema } from './credit-safe.company.search.result';

export const CreditSafeCompanySchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z.string(),
        searchQuery: CreditSafeCompanySearchQuerySchema.nullish(),
        searchResult: CreditSafeCompanySearchResultSchema.nullish(),
        match: BusinessMatchSchema.nullish(),
        rawData: z.any().nullish(),
    }),
).strict();

export class CreditSafeCompany extends FromSchema(CreditSafeCompanySchema) implements SegmentEntity {
    id: string;
    buyer: string;
    searchQuery?: CreditSafeCompanySearchQuery;
    searchResult?: CreditSafeCompanySearchResult;
    match?: BusinessMatch;
    rawData?: any;

    tenantId: string;
    seller: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    segments?: Segment[];
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
